<template>
  <div class="row">
    <div class="col-12">
      <h1>Les demanes de congés</h1>
      <router-link class="btn btn-block btn-info px-3 py-4 w-100 mb-2 fw-bold" to="/">
        <i class="far fa-home"></i> Retour à l'accueil
      </router-link>
    </div>
  </div>

  <n-list hoverable clickable>
    <n-list-item v-if="leaves.length" v-for="leave in leaves">
      <n-thing :title="'Du : ' + formatDate(leave.start) + ' au ' + formatDate(leave.end)" content-style="margin-top: 10px;">
        <template #description>

          <ul>
            <li><i class="fas fa-calendar-alt"></i><span style="font-weight: bold;">Date de la demande </span>: {{formatDateTime(leave.created)}} <br></li>
            <li><i class="fas fa-user"></i>  <span style="font-weight: bold;">Demandeur </span>: {{leave.expand.applicant.name}} <br></li>
            <li><span style="font-weight: bold;">Type de congés </span>: {{leave.type}} <br></li>
            <li><span style="font-weight: bold;">Commentaire </span>:<br/><span style="white-space: pre;">{{leave.comment}}</span> <br></li>
          </ul>

          <div v-if="leave.justificatifs && leave.justificatifs.length" class="attachments-section mt-2">
            <p class="fw-bold">Pièces jointes :</p>
            <ul class="attachments-list">
              <li v-for="justificatif in leave.justificatifs">
                <a target="_blank" :href="justificatif.url" class="attachment-link">
                  <i class="fas fa-paperclip me-1"></i>
                  {{ justificatif.title }}
                </a>
              </li>
            </ul>
          </div>
        </template>

        <!-- button to display a textarea add validator comment -->

        <n-input v-model:value="validatorcomment " type="textarea" rows="3" placeholder="Ajouter un commentaire" />


        <n-popconfirm v-if="leave.status == 'pending'"
            @positive-click="handleValidateClick(leave)"
        >
          <template #trigger>
            <n-button  type="success">Valider la demande</n-button>
          </template>
          Es tu sûr de vouloir valider la demande ?
        </n-popconfirm>

        <n-popconfirm v-if="leave.status == 'pending'"
                      positive-text="Refuser"
                      @positive-click="handleConfirmeRefuelling(leave)"
        >
            <template #trigger>
                <n-button quaternary type="error" >Refuser la demande</n-button>
            </template>
            Es tu sûr de vouloir Refuser la demande ?
        </n-popconfirm>

        <n-popconfirm v-if="leave.status == 'pending'"
                      positive-text="Annuler"
            @positive-click="handleConfirmeCancelLeave(leave)"
        >
          <template #trigger>
            <n-button quaternary type="default">Annuler la demande</n-button>
          </template>
          Es tu sûr de vouloir annuler la demande ?
        </n-popconfirm>

      </n-thing>
    </n-list-item>

    <n-empty description="Toutes les demandes sont validées" v-else>
      <template #icon>
        <n-icon>
          <i class="fas fa-check"></i>
        </n-icon>
      </template>
      <template #extra>

        <n-button size="small" type="info" @click="router.push('/')">
          Retour à l'accueil
        </n-button>

      </template>
    </n-empty>


  </n-list>
</template>

<script setup>
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import {onMounted, ref} from "vue";
import {formatDate, formatDateTime} from '../../plugins/helpers.js'

const store = useStore();
const router = useRouter();
const leaves = ref([]);

const validatorcomment = ref('');

const handleConfirmeCancelLeave = async (leave) => {
  await store.dispatch('cancelLeaveByValidator', {id: leave.id, comment: validatorcomment.value})
  fetchLeaves();
  validatorcomment.value="";
}

const handleConfirmeRefuelling = async (leave) => {
  await store.dispatch('refuellingLeaveByValidator', {id: leave.id, comment: validatorcomment.value})
  fetchLeaves();
  validatorcomment.value="";
}

const handleValidateClick = async (leave) => {
  await store.dispatch('validateLeaveByValidator', {id: leave.id, comment: validatorcomment.value})
  fetchLeaves();
  validatorcomment.value="";
}

async function fetchLeaves() {
  const pb = await store.getters.getPb
  let result = await pb.collection('leaves').getFullList({
    expand: "applicant,validator",
    filter: "status = 'pending'",
    sort: 'created'
  })

  const host = import.meta.env.PROD ? window.location.origin : import.meta.env.VITE_APP_CLIENT_POCKETBASE_URL ?? '/pb';
  const getImageURL = (collectionID, recID, filename) => `${host}/api/files/${collectionID}/${recID}/${filename}`;

  for (let leave of result) {
    if (leave.justificatifs) {
      leave.justificatifs = leave.justificatifs.map(filename => ({
        title: filename,
        url: getImageURL(leave.collectionId, leave.id, filename),
      }))
    }
  }

  leaves.value = result
}

onMounted(async () => {
  await fetchLeaves();
})


</script>